<template>
  <div class="note" :class="modifiers">
    <div v-if="$slots.default" class="note__side">
      <slot />
    </div>
    <div class="note__main">
      <BaseText
        v-if="description"
        v-bind="description"
        class="note__description"
      />
    </div>
  </div>
</template>

<script>
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'BaseNote',
  components: {
    BaseText,
  },
  props: {
    description: {
      type: Object,
      default: null,
    },
    theme: {
      type: String,
      default: 'primary',
    },
  },
  computed: {
    modifiers() {
      return {
        note_slot: Boolean(this.$slots.default),
        [`note_theme_${this.theme}`]: Boolean(this.theme),
      };
    },
  },
};
</script>

<style lang="stylus">
.note
  display flex
  align-items center
  padding 1.25em 1.5em

  &_theme_primary
    background-color $c_tip
    color darken(@background-color, 70%)

  &_theme_secondary
    background-color $c_border
    color darken(@background-color, 70%)

  &__main
  &__side
    flex-grow 1
    flex-basis 0
    max-width 100%

  &__side
    position relative
    max-width 38%
    order 1

  &__main
    max-width 100%
    ~/__side ~ &
      max-width 62%

  &__field
    .field__message
      abs top 100% left right
      margin-top 0.25em
</style>
